import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../../core/clock.js";
import { someMap as e } from "../../../core/MapUtils.js";
import { createScreenPoint as i } from "../../../core/screenUtils.js";
import { DragEventSeparator as a } from "../DragEventSeparator.js";
import { InputHandler as o } from "../InputHandler.js";
import { DefaultParameters as r } from "./SingleAndDoubleClick.js";
import { manhattanDistance as n } from "./support.js";

var s = /*#__PURE__*/function (_o) {
  _inherits(s, _o);

  var _super = _createSuper(s);

  function s() {
    var _this;

    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : r.maximumDoubleClickDelay;
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : r.maximumDoubleClickDistance;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : r.maximumDoubleTouchDelay;

    var _s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : r.maximumDoubleTouchDistance;

    var u = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : t;

    _classCallCheck(this, s);

    _this = _super.call(this, !1), _this.maximumDoubleClickDelay = e, _this.maximumDoubleClickDistance = o, _this.maximumDoubleTouchDelay = n, _this.maximumDoubleTouchDistance = _s, _this._clock = u, _this._doubleTapDragReady = !1, _this._doubleTapDragActive = !1, _this._dragStartCenter = i(0, 0), _this._pointerState = new Map(), _this._doubleTapDrag = _this.registerOutgoing("double-tap-drag"), _this._dragEventSeparator = new a({
      start: function start(t, e) {
        return _this._dragStart(t, e);
      },
      update: function update(t, e) {
        return _this._dragUpdate(e);
      },
      end: function end(t, e) {
        return _this._dragEnd(e);
      }
    }), _this.registerIncoming("drag", function (t) {
      return _this._dragEventSeparator.handle(t);
    }), _this.registerIncoming("pointer-down", function (t) {
      return _this._handlePointerDown(t);
    }), _this.registerIncoming("pointer-up", function () {
      return _this._handlePointerUp();
    });
    return _this;
  }

  _createClass(s, [{
    key: "onUninstall",
    value: function onUninstall() {
      this._pointerState.forEach(function (t) {
        null != t.doubleTapTimeout && (t.doubleTapTimeout.remove(), t.doubleTapTimeout = null);
      });
    }
  }, {
    key: "hasPendingInputs",
    get: function get() {
      return e(this._pointerState, function (t) {
        return null != t.doubleTapTimeout;
      });
    }
  }, {
    key: "_clearPointerDown",
    value: function _clearPointerDown(t) {
      var e = this._pointerState.get(t);

      e && (e.doubleTapTimeout.remove(), e.doubleTapTimeout = null, this._pointerState.delete(t), this.refreshHasPendingInputs());
    }
  }, {
    key: "_createDoubleTapDragData",
    value: function _createDoubleTapDragData(t, e, i) {
      var a = i.button,
          o = i.buttons,
          r = i.pointer,
          n = i.pointers,
          _s2 = i.pointerType,
          u = i.timestamp;
      return {
        action: t,
        delta: e,
        button: a,
        buttons: o,
        pointer: r,
        pointers: n,
        pointerType: _s2,
        timestamp: u
      };
    }
  }, {
    key: "_dragStart",
    value: function _dragStart(t, e) {
      if (!this._doubleTapDragReady || 1 !== t) return;
      this._doubleTapDragReady = !1, this._doubleTapDragActive = !0;
      var a = e.data,
          o = e.modifiers,
          r = a.center;
      this._dragStartCenter = r;

      var n = this._createDoubleTapDragData("begin", i(0, 0), a);

      this._doubleTapDrag.emit(n, void 0, o), e.stopPropagation();
    }
  }, {
    key: "_dragUpdate",
    value: function _dragUpdate(t) {
      if (!this._doubleTapDragActive) return;

      var e = t.data,
          a = t.modifiers,
          o = e.center,
          r = i(o.x - this._dragStartCenter.x, o.y - this._dragStartCenter.y),
          n = this._createDoubleTapDragData("update", r, e);

      this._doubleTapDrag.emit(n, void 0, a), t.stopPropagation();
    }
  }, {
    key: "_dragEnd",
    value: function _dragEnd(t) {
      if (!this._doubleTapDragActive) return;

      var e = t.data,
          a = t.modifiers,
          o = e.center,
          r = i(o.x - this._dragStartCenter.x, o.y - this._dragStartCenter.y),
          n = this._createDoubleTapDragData("end", r, e);

      this._doubleTapDrag.emit(n, void 0, a), this._doubleTapDragActive = !1, t.stopPropagation();
    }
  }, {
    key: "_handlePointerDown",
    value: function _handlePointerDown(t) {
      var e = t.data,
          i = this._pointerId(e),
          a = this._pointerState.get(i),
          o = e.native.pointerType;

      if (a) {
        var _r = "touch" === o ? this.maximumDoubleTouchDistance : this.maximumDoubleClickDistance;

        this._clearPointerDown(i), n(a.event.data, e) > _r ? this._storePointerDown(t) : this._doubleTapDragReady = !0;
      } else this._storePointerDown(t);
    }
  }, {
    key: "_handlePointerUp",
    value: function _handlePointerUp() {
      this._doubleTapDragReady = !1;
    }
  }, {
    key: "_pointerId",
    value: function _pointerId(t) {
      var e = t.native,
          i = e.pointerId,
          a = e.button,
          o = e.pointerType;
      return "mouse" === o ? "".concat(i, ":").concat(a) : "".concat(o);
    }
  }, {
    key: "_storePointerDown",
    value: function _storePointerDown(t) {
      var _this2 = this;

      var e = t.data,
          i = e.native.pointerType,
          a = this._pointerId(e),
          o = "touch" === i ? this.maximumDoubleTouchDelay : this.maximumDoubleClickDelay,
          r = this._clock.setTimeout(function () {
        return _this2._clearPointerDown(a);
      }, o);

      this._pointerState.set(a, {
        event: t,
        doubleTapTimeout: r
      }), this.refreshHasPendingInputs();
    }
  }]);

  return s;
}(o);

export { s as DoubleTapDrag };